import styled from "styled-components";

export const ConfigurationPageStyle = styled.div`
  .configurationCardWidth {
    width: 60vh !important;
  }

  .configurationCard {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 80vh;
    margin-bottom: 5vh;
    margin-top: 5vh;
    overflow-wrap: anywhere;
    justify-content: space-between;
    align-self: center;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }

  .green .input-range__track--active {
    background-color: green;
  }

  .green .input-range__slider {
    background-color: green;
    border-color: green;
  }

  .yellow .input-range__track--active {
    background-color: yellow;
  }

  .yellow .input-range__slider {
    background-color: yellow;
    border-color: yellow;
  }

  .red .input-range__track--active {
    background-color: red;
  }

  .red .input-range__slider {
    background-color: red;
    border-color: red;
  }

  .form-button {
    width: 20vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
  }

  h5 {
    align-self: start;
    margin-top: 25px;
    margin-bottom: 20px;
    font-family: "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica,
      "Arial Narrow", sans-serif;
  }

  .form-check {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .form-check-label {
    margin-left: 15px;
  }

  .form-check-input:checked {
    background-color: #f28809;
    border-color: #f28809;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    font-family: thin-pro, sans-serif;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }

  .trigger-div {
    display: flex;
    justify-content: space-between;
  }

  .row-div {
    border: 20px solid white;
  }

  .field-div {
    display: flex;
    justify-content: end;
    margin-right: 5px;
    font-family: medium-pro, sans-serif;
  }

  .react-time-picker__wrapper {
    border: thin solid #dee2e6;
    border-radius: 5px;
  }

  .react-time-picker__button:enabled:hover .react-time-picker__button__icon,
  .react-time-picker__button:enabled:focus .react-time-picker__button__icon {
    stroke: #f28809;
  }

  .time-div {
    display: flex;
  }

  .table-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }

  .table-item2 {
    font-family: thin-pro, sans-serif;
  }
  .table-div2 {
    padding: 20px;
    width: 40%;
    display: flex;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }

  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  .delete-icon {
    font-size: 1.2rem;
    color: #dd3e3e;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }

  .table-loading {
    text-align: center;
    font-size: 1rem;
  }
`;

export const TosPageStyle = styled.div`
  .configurationCardWidth {
    width: 100vh !important;
  }
  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    width: 79%;
    font-family: thin-pro, sans-serif;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }
  .configurationCard {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 80vh;
    margin-bottom: 5vh;
    margin-top: 5vh;
    overflow-wrap: anywhere;
    justify-content: space-between;
    align-self: center;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }
  .configurationCardContainer {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    align-items: baseline;
  }

  .label {
    font-family: medium-pro, sans-serif;
    font-weight: bold;
  }

  .form-button {
    width: 30vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
  }

  .table-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }

  .table-div2 {
    padding: 20px;
    width: 60%;
    display: flex;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }
  .table-loading {
    text-align: center;
    font-size: 1rem;
  }

  .RichTextEditor__root___2QXK- {
    height: 300px;
    overflow: scroll;
    width: 79%;
  }

  .label-div {
    width: 150px;
    text-align: right;
  }
  .EditorToolbar__root___3_Aqz {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 2;
  }

  .edit-icon {
    font-size: 1.2rem;
    color: #f28809;
    margin-right: 10px;
    cursor: pointer;
  }
  .delete-icon {
    font-size: 1.2rem;
    color: rgb(242, 75, 9);
    cursor: pointer;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }
`;
